/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState } from 'react';

import { decrypt } from '../../Functions/authentication';
import axiosInstance from '../../services/AxiosInstance';
import { userContext } from '../../contextProvider/Authentication';
import { useEffect } from 'react';
import { useHistory, Link, useLocation } from 'react-router-dom';

import HeaderNav from '../Pages/Public/Dashboard/HeaderNav';
import Notification from './Notification';

const Header = () => {

	const { pathname } = useLocation();
	const { authenticated, setAuthenticated, user, setUser } = useContext(userContext);

	const [logo, setLogo] = useState();
	const [profileupdated, setProfileupdated] = useState(false);
	// eslint-disable-next-line
	const [show, setShow] = useState(false);
	const history = useHistory();
	// eslint-disable-next-line
	const handleClose = () => {
		setShow(false);
	};

	useEffect(() => {
		let t = localStorage.getItem('tenant') && decrypt(localStorage.getItem('tenant'), 'lstenant');
		setLogo(t?.logo);
		if (user && !(user?.role === 1)) {
			axiosInstance(
				"user/has_profile/", {
				method: "GET",
				data: {}
			}).then(res => {
				setProfileupdated(res?.data?.has_profile);
			})
		}
		if (authenticated) {
			// sidebar open/close

			var Navicon = document.querySelector('.navicon');
			var sidebarmenu = document.querySelector('.myNavbar ');

			function toggleFunc() {
				sidebarmenu.classList.toggle('show');
			}
			Navicon.addEventListener('click', toggleFunc);

			// Sidenav li open close
			var navUl = [].slice.call(document.querySelectorAll('.navbar-nav > li > a, .sub-menu > li > a'));
			for (var y = 0; y < navUl.length; y++) {
				navUl[y].addEventListener('click', function () { checkLi(this) });
			}

			function checkLi(current) {
				current.parentElement.parentElement.querySelectorAll("li").forEach(el =>
					(current.parentElement !== el) ? el.classList.remove('open') : ''
				);
				setTimeout(() => {
					current.parentElement.classList.toggle('open');
				}, 100);
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user])

	const onLogout = () => {
		localStorage.removeItem('access');
		localStorage.removeItem('user');
		localStorage.removeItem('pimg');
		setAuthenticated(false);
		setUser({});
		history.push('/');
	}

	var candidate = [
		{ link: "/candidate/jobs-profile", name: "My Profile" },
		{ link: "/candidate/jobs-my-resume", name: "My Resume", className: "custom-disabled" },
		{ link: "/candidate/jobs-applied-job", name: "Applied Job", className: "custom-disabled" },
		{ link: "/candidate/jobs-saved-jobs", name: "Saved Job", className: "custom-disabled" },
		{ link: "/candidate/feedback", name: "Feedback", className: "custom-disabled" },
		{ link: "/candidate/candidate-change-password", name: "Change Password", className: "custom-disabled" },
	]

	var employer = [
		{ link: "/employer/company-profile", name: "Company Profile" },
		{ link: "/employer/sub-users", name: "Users", className: "custom-disabled" },
		{ link: "/employer/company-post-jobs", name: "Post Job", className: "custom-disabled" },
		{ link: "/employer/company-manage-job", name: "Manage jobs", className: "custom-disabled" },
		// { link: "/company-resume", name: "Employer Resume", className: "custom-disabled" },
		{ link: "/employer/company-transactions", name: "Transactions", className: "custom-disabled" },
		{ link: "/employer/work-flow", name: "Work Flow", className: "custom-disabled" },
		// { link: "/browse-candidates", name: "Browse Candidates", className: "custom-disabled" },
		{ link: "/employer/employer-change-password", name: "Change Password", className: "custom-disabled" },
		// { link: "/employer-feedback", name: "Employer Feedback", className: "custom-disabled" },
	]

	var joc = [
		// { link: "/institution-profile", name: "Profile" },
		{ link: "/joc/employers", name: "Employer" },
		{ link: "/joc/candidates", name: "Candidate" },
		{ link: "/joc/all-jobs", name: "Jobs" },
		{ link: "/joc/candidate-application", name: "Candidate Applications" },
		{ link: "/joc/joc-transactions", name: "Transactions" },
		{ link: "/joc/filter-candidates", name: "Filter Candidates" },

	]

	var jocsupport = [
		{ link: "/joc/qualification-level", name: "Qualification Level" },
		{ link: "/joc/qualifications", name: "Qualification" },
		{ link: "/joc/courses", name: "Courses" },
		{ link: "/joc/specializations", name: "Specialization" },
		{ link: "/joc/job-categories", name: "Job Categories" },
		{ link: "/joc/job-types", name: "Job Types" },
		{ link: "/joc/job-titles", name: "Job Titles" },
		{ link: "/joc/industries", name: "Industries" },
		{ link: "/joc/company-types", name: "Company Types" },
		{ link: "/joc/career-levels", name: "Career Levels" },
		{ link: "/joc/company-categories", name: "Company Categories" },
		{ link: "/joc/languages", name: "Languages" },
		{ link: "/joc/cities", name: "Cities" },
		{ link: "/joc/states", name: "States" },
		{ link: "/joc/countries", name: "Countries" },

	]

	var menu = {
		1: joc,
		4: candidate,
		2: employer,
		3: employer,
	}

	var submenu = {
		1: jocsupport,
	}

	var urls = {
		1: "/joc",
		4: "/candidate",
		3: "/employer",
		2: "/employer",
	}

	return (
		<>
			{
				!(['/login', '/register'].includes(pathname)) && <>
					{
						authenticated ?
							<header className="site-header mo-left header fullwidth">
								<div className="sticky-header main-bar-wraper navbar-expand-lg">
									<div className="main-bar clearfix">
										<div className="container clearfix">
											<div className="logo-header mostion">
												<Link to="#"><img src={logo} className="logo" alt="img" /></Link>
											</div>
											<button className="navbar-toggler collapsed navicon  justify-content-end" type="button" data-toggle="collapse">
												<span></span>
												<span></span>
												<span></span>
											</button>
											<div className="extra-nav d-sm-block d-md-none" style={{ display: "contents" }}>
												<div onClick={onLogout}>
													<i style={{ fontSize: "30px", color: "#2e55fa" }} className="m-t10 fa fa-sign-out" />
												</div>
											</div>
											<div className="extra-nav">
												<Notification role={user?.role} uId={user?.id} />
												<span>{user?.first_name}</span>
												<div className="extra-cell">
													<div title="Logout" className="site-button" onClick={onLogout}>
														<i className="fa fa-lock"></i> Logout
													</div>
												</div>
											</div>

											<div className="header-nav navbar-collapse collapse myNavbar justify-content-start" >
												<div className="logo-header mostion d-md-block d-lg-none">
													<Link to={'/'} className="dez-page"><img src={logo} alt="" /></Link>
												</div>
												<ul className="nav navbar-nav">
													<li key="navbarHome" className="">
														<Link to={urls[user?.role]} >Home</Link>
													</li>
													<li key="navbarDropdowns">
														<Link to={'#'} >Menus <i className="fa fa-chevron-down"></i></Link>
														<ul className={`sub-menu`}>
															{
																menu[user?.role]?.map(res => {
																	return (
																		<li key={res.name} className={!profileupdated ? res.className : ""}>
																			<Link
																				to={res.link}
																				className="dez-page"
																			>
																				{res.name}
																			</Link>
																		</li>
																	)
																})
															}
														</ul>
													</li>
													<li key="navbarSubDrowpdown" className={`${!(user?.role === 1) && "d-none"}`}>
														<Link to={'#'} >
															{user?.role === 1 && "Support Data"}
															{user?.role === 1 && <i className="fa fa-chevron-down" />}
														</Link>
														<ul className={`sub-menu`}>
															{
																submenu[user?.role]?.map(res => {
																	return (
																		<li key={res.name} className={!profileupdated && res.className}>
																			<Link
																				to={res.link}
																				className="dez-page"
																			>
																				{res.name}
																			</Link>
																		</li>
																	)
																})
															}
														</ul>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</header>
							:
							<HeaderNav />
					}
				</>
			}
		</>
	)
};

export default Header;


